import { configureStore, TypedStartListening } from '@reduxjs/toolkit';

import { assignmentApi } from 'src/store/api/assignment';
import { classStatsApi } from 'src/store/api/class-stats';
import { clientStateApi } from 'src/store/api/client-state';
import { entrywaysApi } from 'src/store/api/entryways';
import { insightsApi } from 'src/store/api/insights';
import { onboardingApi } from 'src/store/api/onboarding';
import { retailApi } from 'src/store/api/retail';
import { retailCompositeApi } from 'src/store/api/retail-composite';
import { sharedExpBffApi } from 'src/store/api/shared-exp-bff';
import { studentDesmosApi } from 'src/store/api/student-desmos';
import assignmentsViewReducer from 'src/store/features/assignments-view.slice';
import assignmentsXApiPayloadReducer from 'src/store/features/assignments-xapi-payload.slice';
import avatarReducer from 'src/store/features/avatar.slice';
import currentAppViewReducer from 'src/store/features/current-app-view.slice';
import currentGradeReducer from 'src/store/features/current-grade.slice';
import msProductsEntitlementsReducer from 'src/store/features/ms-products-entitlements.slice';
import scheduledAssignmentEventsReducer from 'src/store/features/scheduled-assignment-events.slice';
import singleSessionCodeReducer from 'src/store/features/single-session-code.slice';
import userClassesReducer from 'src/store/features/user-classes.slice';
import {
  scheduledAssignmentEventsListener,
  selectedTeacherClassListener,
} from 'src/store/middleware';

export const store = configureStore({
  reducer: {
    currentGrade: currentGradeReducer,
    avatar: avatarReducer,
    assignmentsView: assignmentsViewReducer,
    assignmentsXApiPayload: assignmentsXApiPayloadReducer,
    userClasses: userClassesReducer,
    scheduledAssignmentEvents: scheduledAssignmentEventsReducer,
    currentAppView: currentAppViewReducer,
    singleSessionCode: singleSessionCodeReducer,
    msProductsEntitlements: msProductsEntitlementsReducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [assignmentApi.reducerPath]: assignmentApi.reducer,
    [retailCompositeApi.reducerPath]: retailCompositeApi.reducer,
    [retailApi.reducerPath]: retailApi.reducer,
    [entrywaysApi.reducerPath]: entrywaysApi.reducer,
    [classStatsApi.reducerPath]: classStatsApi.reducer,
    [insightsApi.reducerPath]: insightsApi.reducer,
    [studentDesmosApi.reducerPath]: studentDesmosApi.reducer,
    [sharedExpBffApi.reducerPath]: sharedExpBffApi.reducer,
    [clientStateApi.reducerPath]: clientStateApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      scheduledAssignmentEventsListener.middleware,
      selectedTeacherClassListener.middleware,
      onboardingApi.middleware,
      assignmentApi.middleware,
      retailCompositeApi.middleware,
      retailApi.middleware,
      entrywaysApi.middleware,
      classStatsApi.middleware,
      insightsApi.middleware,
      studentDesmosApi.middleware,
      sharedExpBffApi.middleware,
      clientStateApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
